'use strict';

document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-element-carousel]')).forEach(function (element) {
        var dots = element.querySelector(".element-carousel__dots");

        if (dots) {
            function handleDotEvent(e) {
                if (e.type === "after.lory.slide") {
                    var dot = dots.querySelectorAll("li")[e.detail.currentSlide - 1];
                    dots.querySelector("ul").scrollLeft = dot.offsetLeft;
                }
            }

            element.addEventListener("after.lory.init", handleDotEvent);
            element.addEventListener("after.lory.slide", handleDotEvent);
        }
    });
});